export default "__VITE_ASSET__903cfea7__"